import '../App.css';

import {AdminList} from '../components/adminlist';

export function Admins(props) {
    return (
        <div className="App-header">
            <AdminList/> 
        </div>
    );
}